import(/* webpackMode: "eager" */ "/opt/customer-accounts/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/opt/customer-accounts/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/opt/customer-accounts/src/components/QueryClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/components/TitanPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitanAnalyticsWrapper"] */ "/opt/customer-accounts/src/hooks/useTitanAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/opt/customer-accounts/src/lib/analytics/webVitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/lib/error/ServerError.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider","CssBaseline"] */ "/opt/customer-accounts/src/lib/mui.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/customer-accounts/src/lib/theme.ts");
